import * as Sentry from '@sentry/vue'
import { browserTracingIntegration } from '@sentry/vue'
import { captureAudienceSnapshot, getAudienceTags } from '../utils/audienceTags'

const appEnv = import.meta.env.VITE_APP_ENV // 'dev' | 'production' — из CI через vite.config.js

export function setupSentry(app, router, store) {
  captureAudienceSnapshot()

  const applySegmentationTags = (event) => {
    if (store?.state?.country?.code) {
      event.tags = {
        ...event.tags,
        country: store.state.country.code,
      }
    }
    event.tags = {
      ...event.tags,
      authed: String(!!store?.state?.authed),
      ...getAudienceTags({ store }),
    }
    return event
  }

  Sentry.init({
    app,
    enabled: true,
    environment: appEnv,
    release:
      appEnv === 'production' ? import.meta.env.VITE_SENTRY_RELEASE : undefined,
    dsn: 'https://47a126afe328c5745dd4581cf297f052@sentry.coral.club/2',
    replaysSessionSampleRate: appEnv === 'dev' ? 1.0 : 0.4,
    replaysOnErrorSampleRate: 1,
    sendDefaultPii: true,
    integrations: [
      browserTracingIntegration({
        router,
        idleTimeout: 20000,
        finalTimeout: 30000,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        ignore: ['.ignore-me'],
        mutationLimit: 15000,
        mutationBreadcrumbLimit: 1000,
        minReplayDuration: 10000,
      }),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: [
            'StepFio',
            'FioBlock',
            'StepCity',
            'StepDeliveryType',
            'DeliveryTypes',
            'CourierAddress',
            'PostAddress',
            'ChoosePickpoints',
          ],
          hooks: ['mount'],
        },
      }),
    ],
    ignoreErrors: [
      /ym is not defined/,
      /Network Error/,
      /Can't find variable: ym/,
      /undefined is not an object \(evaluating 'e\.geometry\.location'\)/,
      /Cannot read properties of undefined \(reading 'location'\)/,
      /window\.ym is not a function/,
    ],
    denyUrls: [
      /local\/templates\/cc_new\/script/,
      /local\/templates\/cc_new\//,
      /maps\/api\/js/,
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^\//],
    logErrors: true,
    initialScope: {
      tags: {
        country: store?.state?.country?.code,
      },
    },
    beforeSend(event) {
      return applySegmentationTags(event)
    },
    beforeSendTransaction(event) {
      return applySegmentationTags(event)
    },
  })

  if (store?.state?.country?.code) {
    Sentry.setTag('country', store.state.country.code)
  }
}
